import useFetch from '../../../hooks/useFetch';
import { Link } from 'react-router-dom';

export default function Blogs() {
  const { data: blogPosts } = useFetch('/blogs/', 'GET');

  return (
      <ul className="p-10 space-y-6">
          {blogPosts ? blogPosts.map((blog) => (
            <Link to={`/blog/${blog.id}/${blog.slug}`} key={blog.id}>
              <li
                className="text-center text-white px-10 py-8 border-4 rounded-md border-black m-auto
                hover:scale-105 duration-100 cursor-pointer bg-blue-600 my-5"
              >
                <p className="md:text-2xl text-lg text-bold black-ops-font">{blog.title}</p>
                <p className='my-3'>by {blog.author} | {blog.posted_on}</p>
              </li>
            </Link>
          )) : (
            <div>My backend server is temporarily shut off. Please come back later.</div>
          )}
      </ul>
  )
}
